// TODO add tests

import formatMeasure from 'utils/loads/formatters/formatMeasure';

const isNextValue = (v, valueToNextUnit) =>
  valueToNextUnit > 0 ? v < valueToNextUnit : v;

const formatMeasureGroup = ({ width, length, t, showParens = false }) => {
  const widthValueToNextUnit = Number.MAX_SAFE_INTEGER;
  const lengthValueToNextUnit = 250;

  const showUnit =
    isNextValue(width, widthValueToNextUnit) &&
    !isNextValue(length, lengthValueToNextUnit);

  const widthFormatted = formatMeasure({
    value: width,
    t,
    valueToNextUnit: widthValueToNextUnit,
  });
  const lengthFormatted = formatMeasure({
    value: length,
    t,
    valueToNextUnit: lengthValueToNextUnit,
    showUnit,
  });

  return `${(showParens && '(') || ''}${t('units:size', {
    width: widthFormatted,
    length: lengthFormatted,
  })}${(showParens && ')') || ''}`;
};

export default formatMeasureGroup;
